module.exports = {"dashboard":"Instrumententafel","dashboardItems":{"versionOne":"Version Eins","versionTwo":"Version zwei","versionThree":"Version drei","versionFour":"Version vier"}}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/lang/i18n/de.json
// module id = 5p0r
// module chunks = 35